// extracted by mini-css-extract-plugin
export default {"loginForm":"loginForm_dX35k","loginToTripspirationsLabel":"loginToTripspirationsLabel_bjkQ7"};